import api from "./api";
import { SESSION_KEEPALIVE_ENABLED } from "../config/sessionKeepAlive";

/** Keep-alive uses a short timeout so a hung API does not block the heartbeat loop. */
const KEEPALIVE_TIMEOUT_MS = 30_000;

/**
 * GET /api/session/keepalive — renews cookie session and returns remaining lifetime.
 * No-op when SESSION_KEEPALIVE_ENABLED is false.
 * @returns {Promise<{ success: boolean, serverTime?: string, sessionExpiresIn?: number } | null>}
 */
export async function fetchSessionKeepAlive() {
  if (!SESSION_KEEPALIVE_ENABLED) {
    return null;
  }
  const response = await api.get("/api/session/keepalive", {
    timeout: KEEPALIVE_TIMEOUT_MS,
    __skipSessionGuard: true,
    __skipClientLog: true,
  });
  return response.data;
}

export const sessionAPI = {
  keepAlive: fetchSessionKeepAlive,
};
